import { render } from "./CalcSection.vue?vue&type=template&id=3ea2461d&scoped=true"
import script from "./CalcSection.vue?vue&type=script&lang=js"
export * from "./CalcSection.vue?vue&type=script&lang=js"

import "./CalcSection.vue?vue&type=style&index=0&id=3ea2461d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea2461d"]])

export default __exports__